import type { ReactNode } from 'react'
import { Interaction } from '@/shared/ui/Interaction'

export function SidebarItem({
  selected = false,
  icon,
  chevron,
  className = '',
  children,
}: {
  selected?: boolean
  icon?: ReactNode
  chevron?: ReactNode
  className?: string
  children: ReactNode
}) {
  return (
    <span
      className={['relative flex h-10 items-center gap-2', className].filter(Boolean).join(' ')}
    >
      {selected && <Interaction state="select" className="absolute -inset-y-[3px] -inset-x-2.5" />}

      <span className="relative flex min-w-0 flex-1 shrink-0 grow basis-0 items-center gap-2 text-body-md font-medium text-black [&>svg]:shrink-0 [&>svg]:text-black-600">
        {icon}
        {children}
      </span>

      {chevron !== undefined && (
        <span className="relative inline-flex shrink-0 text-black-600">{chevron}</span>
      )}
    </span>
  )
}
